<template>
	<HeroLayout>
		<div class="flex flex-col w-full h-full">
			<img class="registration-title-image" :src="logoPath" alt="Logo" />
			<p class="registration-title">Forgot your password?</p>
			<p class="registration-subtitle mt-1 mb-10">Enter your email address and we’ll send instructions to reset your password.</p>
			<form>
				<InputText label="Email address*" type="email" class="userpilot-mask" autocomplete="email" placeholder="Enter your email address" v-model="email"
							  :errors="error" error-field="user.email" />

				<div v-if="emailSent" class="flex rounded-lg bg-success text-grayscale-body font-medium text-sm px-4 py-2">
					<img src="@/assets/images/icon/checkmark-rounded-green-bg.svg" alt="Email sent" title="Email Sent" class="mr-3.5" />
					If an account exists for the email address you provided, a password reset link will be sent to it shortly. Please check your inbox and your spam folder.
				</div>

				<SubmitButton class="ml-auto mt-10" label="Send" :loading="isLoading" @click="sendPasswordResetEmail" />
				<ValidationError :errors="error" :field="null" />

				<p class="text-grayscale-body text-end mt-3">Don't need to reset your password?
					<router-link :to="{ name: 'auth.login' }" class="clickable-text">Log in</router-link>.
				</p>
			</form>
		</div>
	</HeroLayout>
</template>

<script setup lang="js">
import { onMounted, ref } from 'vue'
import InputText from '@/components/Forms/InputText.vue'
import ValidationError from '@/components/Forms/InputError.vue'
import HeroLayout from '@/layouts/HeroLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import { userApi } from '@/api/User/UserApi.js'
import { Tenants } from '@/models/tenants/Tenants.js'

const isLoading = ref(false)
const error = ref(null)
const email = ref('')
const emailSent = ref(false)
const logoPath = ref('')

onMounted(() => {
	const tenant = Tenants.getTenant()
	logoPath.value = new URL(`../../assets/images/theme/${tenant.registrationLogo.image}`, import.meta.url).href
})

function sendPasswordResetEmail()
{
	error.value = null
	isLoading.value = true
	emailSent.value = false

	userApi.forgotPassword({
		'user': {
			'email': email.value
		}
	}, () => {
		isLoading.value = false
		emailSent.value = true
		email.value = null
	},	(e) => {
		error.value = e.showErrorBanner()
		isLoading.value = false
	})
}
</script>
